import { render, staticRenderFns } from "./UserSkills.vue?vue&type=template&id=15f91f62&"
import script from "./UserSkills.vue?vue&type=script&lang=js&"
export * from "./UserSkills.vue?vue&type=script&lang=js&"
import style0 from "./UserSkills.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports